import { createFileRoute, linkOptions, Outlet, useNavigate } from '@tanstack/react-router';

import { SideMenuLayout } from '@/components/SideMenuLayout';
import { SideMenuNavigation } from '@/components/navigations/SideMenuNavigation';
import { useAppAbility } from '@/hooks/useAppAbility';
import { UserGuard } from '@/modules/UserGuard';
import { Action, Subject } from '@/modules/api';
import { useMyOrganizationQuery } from '@/queries/useMyOrganizationQuery';
import { useUserQuery } from '@/queries/useUserQuery';

const options = [
  linkOptions({ to: '/meine-organisation/stammdaten', label: 'Stammdaten' }),
  linkOptions({
    to: '/meine-organisation/benutzerinnen',
    label: 'Benutzer*innen',
  }),
  linkOptions({ to: '/meine-organisation/stakeholder', label: 'Stakeholder' }),
  linkOptions({ to: '/meine-organisation/importe', label: 'Importe' }),
];

function RouteComponent() {
  const { data: organization } = useMyOrganizationQuery({
    adminLevels: true,
    users: true,
    stakeholders: true,
  });
  const { data: user } = useUserQuery();
  const { ability } = useAppAbility();

  const navigate = useNavigate();

  if (UserGuard.isUser(user) && user.organization && ability?.can(Action.UPDATE, Subject.Organization))
    return (
      <SideMenuLayout title={organization?.name} sideMenu={<SideMenuNavigation options={options} />}>
        <Outlet />
      </SideMenuLayout>
    );

  navigate({ to: '/' });
}

export const Route = createFileRoute('/_authenticated/_management/meine-organisation')({
  component: RouteComponent,
});
